import { useSettingsStore } from '@/stores/settingsStore'

interface PlanChipProps {
  code?: string | null
  prefix?: string
  prominent?: boolean
}

export function PlanChip({ code, prefix, prominent = false }: PlanChipProps) {
  const normalized = (code ?? 'free').toLowerCase()
  const resolvedTheme = useSettingsStore((s) => s.resolvedTheme)
  const light = resolvedTheme === 'light'

  const styles: Record<string, { color: string; bg: string; border: string }> = {
    pro: {
      color: light ? '#6D28D9' : '#B86BFF',
      bg: 'rgba(168,85,247,.12)',
      border: light ? 'rgba(109,40,217,.36)' : 'rgba(168,85,247,.36)',
    },
    team: {
      color: light ? '#0E7490' : '#22D3EE',
      bg: light ? 'rgba(14,116,144,.10)' : 'rgba(34,211,238,.10)',
      border: light ? 'rgba(14,116,144,.32)' : 'rgba(34,211,238,.32)',
    },
    free: {
      color: 'var(--text-muted)',
      bg: 'rgba(128,128,128,.10)',
      border: 'rgba(128,128,128,.25)',
    },
  }

  const style = styles[normalized] ?? styles.free
  const planName = normalized === 'pro' ? 'Pro' : normalized === 'team' ? 'Team' : 'Free'
  const label = prefix ? `${prefix} ${planName}` : planName

  return (
    <span
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: prominent ? '3px 10px' : '1px 8px',
        borderRadius: prominent ? 999 : 6,
        fontSize: prominent ? 11 : 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: style.color,
        background: style.bg,
        border: `1px solid ${style.border}`,
        lineHeight: prominent ? '20px' : '18px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  )
}
